export default __webpack_public_path__ + "static/media/mockup2.4595709b.png";